import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-faq',
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  faqs = [
    {
      question: 'What is this website about?',
      answer: 'This website provides VPN services to ensure online privacy and security.',
      open: false
    },
    {
      question: 'How can I download the app?',
      answer: 'You can download the VPN app from the respective platform store: Google Play, App Store, or our website.',
      open : false
    },
    {
      question: 'Is this service free?',
      answer: 'We offer both free and premium plans. You can check our pricing page for more details.',
      open : false
    },
    {
      question: 'How do I contact support?',
      answer: 'You can reach our support team via email or through the support page on our website.',
      open : false
    },
    {
      question: 'How can I become a reseller?',
      answer: 'Please visit the reseller page and apply to join our reseller program.',
      open : false
    }
  ];

  
}
